import { UnitedState } from '@occc-app/design-system';

export type LocationAddressGeolocation = {
  latitude?: number;
  longitude?: number;
};

export const LOCATION_ATTRIBUTE_VALUE = {
  YES: 'YES',
  NO: 'NO',
};

export type ScheduleValues = Record<string, { start: Date; end: Date; isOpenAllDay?: boolean }>;

export type LocationBrandingDetailsValues = {
  primaryColor: string | null;
  secondaryColor: string | null;
};

export type RetailerNetworkLocationDetailsValues = {
  name: string;
  street1: string;
  street2: string;
  city: string;
  state: UnitedState;
  zipCode: string;
  phoneNumber?: string;
  availableServices: string[];
  brandingDetails: LocationBrandingDetailsValues | null;
};

export type RetailerNetworkLocationUpdateFormValues = {
  details: RetailerNetworkLocationDetailsValues;
  geoLocation: LocationAddressGeolocation | null;
  schedule: ScheduleValues;
  applyToAllStores: boolean;
  availableDays: string[];
};

export type RetailerNetworkLocationDetailInitialValues = Omit<
  RetailerNetworkLocationDetailsValues,
  'state'
> & {
  state?: UnitedState;
};

export type RetailerNetworkLocationUpdateFormInitialValues = Omit<
  RetailerNetworkLocationUpdateFormValues,
  'details'
> & {
  details: RetailerNetworkLocationDetailInitialValues;
  applyToAllStores?: boolean;
};
